<script setup>
const emit = defineEmits(['handleButtonClick'])

const props = defineProps({
  text: { type: String, default: '' },
  buttonText: { type: String, default: '' },
  buttonIcon: { type: String, default: '' },
});
</script>

<template>
  <section>
    <div
      class="
        flex items-center justify-between gap-x-1.5 px-3 py-2.5 md:px-4 md:py-3 lg:px-6 lg:py-4 bg-yellow-100
      "
    >
      <span class="text-xs text-yellow-600">{{ text }}</span>

      <div class="flex items-center gap-x-2 text-xs md:text-sm text-tint-1 font-semibold flex-none">

        <button @click="emit('handleButtonClick')">
          {{ buttonText }}
        </button>

        <Icon :icon="buttonIcon" class="text-base" />
      </div>
    </div>
  </section>
</template>